import { useEffect, useState } from "react";
import { BsPersonCircle } from "react-icons/bs";
import { useSelector } from "react-redux";
import { getActiveTenantName } from "../../Logic/Auth/TokenManager";
import { RootState } from "../../state/store";
import "./styles.scss";
import { GetUserProfileData, GetUserResponse } from "./tenantApiCall";

interface GeneralProps {
    onEditProfile: () => void;
    onRequestMailboxAccess: () => void;
}

function General({ onEditProfile, onRequestMailboxAccess }: GeneralProps) {
    const [userProfile, setUserProfile] = useState<GetUserResponse>();
    const UserInfo = useSelector((state: RootState) => state.UserInformation);

    useEffect(() => {
        const fetchUserData = async () => {
            const response = await GetUserProfileData(UserInfo.userID);
            if (!response.isOk || !response.data) return;

            setUserProfile(response.data);
        };

        fetchUserData();
    }, []);

    return (
        <>
            <div className="header">
                Details{" "}
                <div style={{ textAlign: "right", float: "right", marginRight: "10px" }}>
                    <button
                        className="g-btn-action"
                        style={{ fontSize: "9pt", textAlign: "right" }}
                        onClick={onEditProfile}
                    >
                        {" "}
                        Edit Profile
                    </button>
                </div>
            </div>
            <div style={{ padding: "20px", paddingTop: "13px" }}>
                <div className="row">
                    <div className="col-sm-12 userPrefViewedHeader">
                        <div className="profile-container">
                            <div className="user-info-row">
                                <BsPersonCircle
                                    size={80}
                                    className="user-icon"
                                />
                                <div className="user-details">
                                    <p>
                                        <strong>{userProfile?.firstName + " " + userProfile?.lastName}</strong>
                                    </p>
                                    {userProfile?.profile_email && (
                                        <p>
                                            <span>Email: {userProfile?.profile_email}</span>
                                        </p>
                                    )}
                                    <p>
                                        <span>Alias: {userProfile?.externalUserID}</span>
                                    </p>
                                </div>
                            </div>

                            <div className="profile-description">
                                <table className="roles-table">
                                    <thead>
                                        <tr>
                                            <th>Profile Description</th>
                                            <th>Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Tenant</td>
                                            <td>{getActiveTenantName(false)}</td>
                                        </tr>
                                        <tr>
                                            <td>Department</td>
                                            <td>{userProfile?.departmentName}</td>
                                        </tr>

                                        <tr>
                                            <td>Global Role</td>
                                            <td>{userProfile?.globalRoleName}</td>
                                        </tr>
                                        <tr>
                                            <td>Job Title</td>
                                            <td>
                                                {userProfile?.profile_jobTitle === undefined
                                                    ? UserInfo.jobTitle
                                                    : userProfile?.profile_jobTitle}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <br />
                            <table className="roles-table">
                                <thead>
                                    <tr>
                                        <th>Department</th>
                                        <th>Mailbox</th>
                                        <th>Role</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userProfile && userProfile.mailboxMembership.length === 0 && (
                                        <tr>
                                            <td colSpan={3}>
                                                No mailbox access.
                                                <button
                                                    className="g-btn-action"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={onRequestMailboxAccess}
                                                >
                                                    Request Access
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                    {userProfile?.mailboxMembership
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.departmentName < b.departmentName) return -1;
                                            if (a.departmentName > b.departmentName) return 1;

                                            if (a.mailboxName < b.mailboxName) return -1;
                                            if (a.mailboxName > b.mailboxName) return 1;

                                            return 0;
                                        })
                                        .map((role: any) => (
                                            <tr>
                                                <td>{role.departmentName}</td>
                                                <td>{role.mailboxName}</td>
                                                <td>{role.roleName}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <br></br>
                <div className="row">
                    <div className="col-sm-5"></div>
                    <div className="col-sm-7"></div>
                </div>
            </div>
        </>
    );
}
export default General;
